export default __webpack_public_path__ + "static/22-5a180e3ab0d936c76b6cd707a3470241.png";